// extracted by mini-css-extract-plugin
export var csatScore = "_na-5";
export var header = "_na-1";
export var panelWrapper = "_na-2";
export var postPreview = "_na-3";
export var rightContent = "_na-0";
export var wrappingText = "_na-4";